import React from 'react'; 
import Background from '../../../components/patientApp/background/background'
import ExtendChatComp from '../../../components/patientApp/patientChat/extendChat/extendchat';

const ExtendChat = () => {
    return <Background>
        <ExtendChatComp />
    </Background>
}
export default ExtendChat;